import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable()
export class RoutingService {

    get routes(): Observable<ActivatedRoute> {
        return this._router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                map(() => this._activatedRoute),
                map(route => {
                    while (route.firstChild) {
                        route = route.firstChild;
                    }
                    return route;
                }),
                filter(route => route.outlet === 'primary')
            );
    }

    constructor(private _router: Router,
        private _activatedRoute: ActivatedRoute) {
    }
}